import { NotificationsResponse } from './types'

import { client } from 'src/utils/client'
import config from 'src/config'

export const getNotifications = async (page?: {
  skip: number
}): Promise<NotificationsResponse> => {
  const paginationQuery = page ? `?$skip=${String(page.skip)}` : ''

  return await client(`${config.HOST_API}/notifications${paginationQuery}`)
}
